import { Injectable } from '@angular/core';
import { CoreServiceService } from './core/core-service.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  constructor(private coreService: CoreServiceService) {

  }

  initializeApp(): Promise<any> {
    return new Promise((resolve) => {
      let $appsettings = this.coreService.loadAppSettings();
      $appsettings.then((appsettings) => {

        if (!appsettings) {
          alert('something went wrong');

        }
        resolve(1);
      })
    })
  }
}
